(function () {
    function loadScript(src, opts) {
      opts = opts || {};
      return new Promise(function (resolve, reject) {
        var s = document.createElement('script');
        s.src = src;
        s.async = opts.async !== undefined ? opts.async : true;
        if (opts.id) s.id = opts.id;
        s.onload = resolve;
        s.onerror = reject;
        (opts.target || document.head).appendChild(s);
      });
    }
  
    // ---- Skio volume discount (only if ATC exists) ----
    function LoadSkio() {
      if (!document.querySelector('[data-add-to-cart]')) return;
      loadScript(window.__ASSET_SKIO_VOLUME_DISCOUNT__, { async: true });
    }
  
    // ---- Rebuy custom (load on first interaction) ----
    var rebuyLoaded = false;

    function loadRebuyCustomOnce() {
      if (rebuyLoaded) return;
      rebuyLoaded = true;
      loadScript(window.__ASSET_REBUY_CUSTOM__, { async: true });
    }
  
    function onFirstUserInteraction(fn) {
      var fired = false;
      function handler() {
        if (fired) return;
        fired = true;
        fn();
      }
      ['scroll', 'touchstart', 'keydown', 'pointerdown'].forEach(function (ev) {
        window.addEventListener(ev, handler, { once: true, passive: true });
      });
    }
  
    // Run after DOM is ready
    document.addEventListener('DOMContentLoaded', function () {
      LoadSkio();
  
      onFirstUserInteraction(loadRebuyCustomOnce);
    });
  })();
  